<template>
  <div>

        <div class="ag-table" :class="{
          'full-height': isFullHeight,
          'mobile':isMobile,
          'extended':withSidebarExtended}">

          <div class="corner">
            <div class="corner-title">
              <span class="pa-2">
                {{config.sidebar.title}}
              </span>
            </div >
            <div class="extend-corner" v-if="withSidebarExtended">
              <div class="ex-corner-title">
                <span class="pa-2" v-if="withTotalSidebar">
                    Total
                </span>
              </div>
            </div>
            <div class="extend-bottom-corner">

            </div>
          </div>



          <div class="container-tl">

            <header>
              <div class="header-container" :style="{ width: (widthContainer) + 'px' }">
                <v-row no-gutters class=" flex-nowrap">
                  <v-col class="header-item"
                  :class="[
                    headItem.print == false ? 'd-print-none' : '',
                    headItem.print_width    ? 'print-'+headItem.print_width : '',
                    headItem.cell_width     ? 'width-'+headItem.cell_width : ''
                    ]"
                  v-for="(headItem, index) in config.header"
                  :key="'header-item-'+index">
                    <v-tooltip bottom v-if="headItem.tooltip" >
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="d-print-none">
                          {{getHead(headItem)}}
                        </span>
                      </template>
                      <span> {{getHead(headItem, 'tooltip')}} </span>
                    </v-tooltip>
                    <span v-else class="d-print-none"> {{getHead(headItem)}} </span>
                    <span class="d-none d-print-block">
                      {{getHead(headItem, 'print')}}
                    </span>
                  </v-col>
                </v-row>
              </div>
              <!--
              <div class="header-extend-container">
                test
              </div>
            -->
            </header>











            <nav class="left" >
              <div class="nav-item-list">


                <div class="nav-item"
                v-for="(item, index) in dataTableFormated"
                :key="'tr-'+index"
                :class="[
                    index%2==0 ? 'odd-nav-item primary lighten-5':' grey lighten-5',
                    item.children ? 'has-children' : null
                  ]">

                  <v-btn color="grey"
                  class="tree-icon ml-2 mr-1"
                  icon x-small
                  height="28"
                  width="28"
                  @click="toggleShowChildren(item)"
                  v-show="item.children"
                  :class="{rotate: item.isShowedChildren}">
                    <v-icon>keyboard_arrow_down</v-icon>
                  </v-btn>

                <div class="item-title px-2 py-1 blue-grey--text text--darken-3 truncate"
                :class="{
                  'clickeable' : sidebarClickeable
                }" @click="clickSidebarItem(item)">
                  {{item[config.sidebar.label]}}
                </div>






                <div class="child-nav-item ml-5"
                v-for="(childItem, childIndex) in item.children"
                :key="'tr-ch-'+index+'-'+childIndex"
                :class="index%2==0?'odd-nav-item primary lighten-4':' grey lighten-3'"
                v-show="item.isShowedChildren">

                  <v-btn color="grey"
                  class="tree-icon ml-2 mr-1"
                  icon x-small
                  height="28"
                  width="28"
                  @click="toggleShowChildren(childItem)"
                  v-if="childItem.children"
                  :class="{rotate: childItem.isShowedChildren}">
                    <v-icon>keyboard_arrow_down</v-icon>
                  </v-btn>

                  <v-btn color="grey" class="tree-icon ml-2 mr-1"
                  icon x-small
                  v-else>
                    <v-icon>arrow_right_alt</v-icon>
                  </v-btn>


                <div class="item-title px-2 py-1 blue-grey--text text--darken-3 truncate"
                :class="{
                  'clickeable' : sidebarClickeable
                  }" @click="clickSidebarItem(childItem)">
                  {{childItem[config.sidebar.label]}}
                </div>









                          <div class="child-nav-item ml-5"
                          v-for="(childItem_2, childIndex_2) in childItem.children"
                          :key="'tr-ch2-'+index+'-'+childIndex+'-'+childIndex_2"
                          :class="index%2==0?'odd-nav-item primary lighten-3':' grey lighten-2'"
                            v-show="childItem.isShowedChildren">

                            <v-btn color="grey"
                            class="tree-icon ml-2 mr-1"
                            icon x-small
                            height="28"
                            width="28"
                            @click="toggleShowChildren(childItem_2)"
                            v-if="childItem_2.children"
                            :class="{rotate:childItem_2.isShowedChildren}">
                            <v-icon>keyboard_arrow_down</v-icon>
                          </v-btn>

                          <v-btn color="grey" class="tree-icon ml-2 mr-1"
                          icon x-small
                          height="28"
                          width="28"
                          v-else>
                          <v-icon>arrow_right_alt</v-icon>
                        </v-btn>


                        <div class="item-title px-2 py-1 blue-grey--text text--darken-3 truncate"
                        :class="{
                          'clickeable' : sidebarClickeable
                          }" @click="clickSidebarItem(childItem_2)">
                          {{childItem_2[config.sidebar.label]}}
                        </div>



















                          <div class="child-nav-item ml-5"
                          v-for="(childItem_3, childIndex_3) in childItem_2.children"
                          :key="'tr-ch2-'+index+'-'+childIndex+'-'+childIndex_2+'-'+childIndex_3"
                          :class="index%2==0?'odd-nav-item primary lighten-2':' grey lighten-1'"
                            v-show="childItem_2.isShowedChildren">

                            <v-btn color="grey"
                            class="tree-icon ml-2 mr-1"
                            icon x-small
                            height="28"
                            width="28"
                            @click="toggleShowChildren(childItem_3)"
                            v-if="childItem_3.children && childItem_3.children.length > 0"
                            :class="{rotate:childItem_3.isShowedChildren}">
                            <v-icon>keyboard_arrow_down</v-icon>
                          </v-btn>

                          <v-btn color="grey" class="tree-icon ml-2 mr-1"
                          icon x-small
                          height="28"
                          width="28"
                          v-else>
                          <v-icon>arrow_right_alt</v-icon>
                        </v-btn>


                        <div class="item-title px-2 py-1 blue-grey--text text--darken-3 truncate"
                        :class="{
                          'clickeable' : sidebarClickeable
                          }" @click="clickSidebarItem(childItem_3)">
                          {{childItem_3[config.sidebar.label]}}
                        </div>










                        </div> <!-- child-nav-item -->
                  </div> <!-- child-nav-item -->
              </div> <!-- child-nav-item -->



              </div> <!-- nav-item -->

                <!-- <div v-if="withTotalsFooter" class="nav-item blue-grey px-3 white--text font-weight-bold nav-item-total-footer">
                Total
              </div> -->

            </div> <!-- nav-item-list -->












          <div class="extend-nav-list"  v-if="withSidebarExtended">

            <div class="ex-nav-item"
            v-for="(item , index) in dataTableFormated"
            :key="'tr-ex-'+index"
            :class="index%2==0?'odd-nav-item primary lighten-5':' grey lighten-5'">

              <div class="num" v-if="withTotalSidebar && item.total && totalCurrency">
                $ {{formatPrice(item.total[config.varSelected])}}
              </div>

              <div class="num" v-if="withTotalSidebar && item.total && !totalCurrency">
                {{item.total[config.varSelected ]}}
              </div>

                <div class="child-ex-nav-item"
                v-for="(childItem, childIndex) in item.children"
                :class="index%2==0?'odd-nav-item primary lighten-4':' grey lighten-3'"
                :key="'tr-ch-ex-'+index+'-'+childIndex"
                v-show="item.isShowedChildren">

                  <div class="num" v-if="withTotalSidebar && childItem.total && totalCurrency">
                    $ {{formatPrice(childItem.total[config.varSelected ])}}
                  </div>

                  <div class="num" v-if="withTotalSidebar && childItem.total && !totalCurrency">
                    {{childItem.total[config.varSelected ]}}
                  </div>


                    <div class="child-ex-nav-item"
                    v-for="(childItem_2, childIndex_2) in childItem.children"
                    :class="index%2==0?'odd-nav-item primary lighten-3':' grey lighten-2'"
                    :key="'tr-ch-ex2-'+index+'-'+childIndex+'-'+childIndex_2"
                    v-show="childItem.isShowedChildren">

                      <div class="num" v-if="withTotalSidebar && childItem_2.total && totalCurrency">
                        $ {{formatPrice(childItem_2.total[config.varSelected ])}}
                      </div>

                      <div class="num" v-if="withTotalSidebar && childItem_2.total && !totalCurrency">
                        {{childItem_2.total[config.varSelected ]}}
                      </div>

                              <div class="child-ex-nav-item"
                              v-for="(childItem_3, childIndex_3) in childItem_2.children"
                              :class="index%2==0?'odd-nav-item primary lighten-3':' grey lighten-2'"
                              :key="'tr-ch-ex2-'+index+'-'+childIndex+'-'+childIndex_2+'-'+childIndex_3"
                              v-show="childItem_2.isShowedChildren">

                                <div class="num" v-if="withTotalSidebar && childItem_3.total && totalCurrency">
                                  $ {{formatPrice(childItem_3.total[config.varSelected ])}}
                                </div>

                                <div class="num" v-if="withTotalSidebar && childItem_3.total && !totalCurrency">
                                  {{childItem_3.total[config.varSelected ]}}
                                </div>

                            </div>

                  </div>
                </div>

            </div>
          </div>

        </nav>









        <v-container class="table pa-0" fluid >



          <v-row class="list-item flex-wrap"
          no-gutters
          v-for="(item, index) in dataTableFormated"
          :key="'list-item-'+index"
          :style="{ width: widthContainer + 'px' }">



          <v-col cols="12">
            <v-row class="flex-nowrap row-items" no-gutters>
              <v-col class="item"
              v-for="(headItem, headIndex) in config.header"
              @click="clickItem(item, headItem)"
              :class="[{
                'primary lighten-5': index % 2 == 0,
                'grey lighten-5': index % 2 == 1,
                'clickeable' : itemClickeable,
                'd-print-none': headItem.print == false
                },
                headItem.print_width    ? 'print-'+headItem.print_width : '',
                headItem.cell_width     ? 'width-'+headItem.cell_width : ''
                ]"
                :key="'item-'+index+'-'+headIndex">

                  <v-btn color="grey"
                  v-if="!item.showOptionalData && headItem.optional && get(item, headItem) != 0"
                  class="my-1 p-absolute left d-print-none"
                  icon x-small
                  height="28"
                  width="28"
                  @click="toggleShowChildren(item)"
                  v-show="item.children"
                  :class="{rotate: item.isShowedChildren}">
                    <v-icon>keyboard_arrow_down</v-icon>
                  </v-btn>

                <span v-if="headItem.currency" v-html="$options.filters.currency(get(item, headItem), headItem.prefix||'', headItem.round)"></span>
                <span v-else>{{get(item, headItem)}}</span>
              </v-col>
            </v-row>
          </v-col>



          <v-col cols="12">

            <v-row class="list-item-children flex-wrap" no-gutters
            v-for="(childItem, childIndex) in item.children"
            v-if="item.isShowedChildren"
            :key="'list-child-'+index+'-'+childIndex"
            :style="{ width: widthContainer + 'px' }">




            <v-col cols="12">
              <v-row class="flex-nowrap row-items" no-gutters>
                <v-col class="item"
                v-for="(headItem,headIndex) in config.header"
                @click="clickItem(childItem, headItem)"
                :class="[{
                  'primary lighten-4': index % 2 == 0,
                  'grey lighten-3': index % 2 == 1,
                  'clickeable' : itemClickeable,
                  'd-print-none': headItem.print == false
                  },
                  headItem.print_width    ? 'print-'+headItem.print_width : '',
                  headItem.cell_width     ? 'width-'+headItem.cell_width : ''
                  ]"
                  :key="'item-child-'+index+'-'+childIndex+'-'+headIndex">

                <v-btn color="grey"
                  v-if="!childItem.showOptionalData && headItem.optional && get(item, headItem) != 0"
                  class="my-1 p-absolute left d-print-none"
                  icon x-small
                  height="28"
                  width="28"
                  @click="toggleShowChildren(childItem)"
                  v-show="childItem.children"
                  :class="{rotate:childItem.isShowedChildren}">
                    <v-icon>keyboard_arrow_down</v-icon>
                  </v-btn>

                <span v-if="headItem.currency" v-html="$options.filters.currency(get(childItem, headItem), headItem.prefix || '', headItem.round)"></span>
                <span v-else>{{get(childItem, headItem, '-')}}</span>
                </v-col>
              </v-row>
            </v-col>



                  <v-col cols="12">
                      <v-row class="list-item-children flex-wrap" no-gutters
                      v-if="childItem.isShowedChildren && item.isShowedChildren"
                      v-for="(childItem_2, childIndex_2) in  childItem.children"
                      :key="'list-child2-'+index+'-'+childIndex+'-'+childIndex_2"
                      :style="{ width: widthContainer + 'px' }">


                      <v-col cols="12">
                        <v-row class="flex-nowrap row-items" no-gutters>
                          <v-col class="item"
                          v-for="(headItem, headIndex) in config.header"
                          @click="clickItem(childItem_2, headItem)"
                          :class="[{
                            'primary lighten-3': index % 2 == 0,
                            'grey lighten-2': index % 2 == 1,
                            'clickeable' : itemClickeable,
                            'd-print-none': headItem.print == false
                            },
                            headItem.print_width    ? 'print-'+headItem.print_width : '',
                            headItem.cell_width     ? 'width-'+headItem.cell_width : ''
                            ]"
                            :key="'item-child2-'+index+'-'+childIndex+'-'+childIndex_2+'-'+headIndex">

                              <v-btn color="grey"
                                v-if="!childItem_2.showOptionalData && headItem.optional && get(item, headItem) != 0"
                                class="my-1 p-absolute left d-print-none"
                                icon x-small
                                height="28"
                                width="28"
                                @click="toggleShowChildren(childItem_2)"
                                v-show="childItem_2.children"
                                :class="{rotate:childItem_2.isShowedChildren}">
                                  <v-icon>keyboard_arrow_down</v-icon>
                                </v-btn>

                              <span v-if="headItem.currency" v-html="$options.filters.currency(get(childItem_2, headItem), headItem.prefix || '', headItem.round)"></span>
                              <span v-else>{{get(childItem_2, headItem)}}</span>

                          </v-col>
                        </v-row >
                      </v-col>

                      <v-col cols="12">
                        <v-row class="list-item-children _4 flex-nowrap" no-gutters
                        v-if="childItem_2.isShowedChildren && childItem.isShowedChildren && item.isShowedChildren"
                        v-for="(childItem_3, childIndex_3) in  childItem_2.children"
                        :key="'list-child2-'+index+'-'+childIndex+'-'+childIndex_2+'-'+childIndex_3"
                        :style="{ width: widthContainer + 'px' }">


                        <v-col cols="12">
                          <v-row class="flex-nowrap row-items" no-gutters>
                            <v-col class="item"
                            v-for="(headItem, headIndex) in config.header"
                            @click="clickItem(childItem_3, headItem)"
                            :class="[{
                              'primary lighten-2': index % 2 == 0,
                              'grey lighten-1': index % 2 == 1,
                              'clickeable' : itemClickeable,
                              'd-print-none': headItem.print == false
                              },
                              headItem.print_width    ? 'print-'+headItem.print_width : '',
                              headItem.cell_width     ? 'width-'+headItem.cell_width : ''
                              ]"
                              :key="'item-child2-'+index+'-'+childIndex+'-'+childIndex_2+'-'+childIndex_3+'-'+headIndex">

                              <v-btn color="grey"
                                v-if="!childItem_3.showOptionalData && headItem.optional && get(item, headItem) != 0"
                                class="my-1 p-absolute left d-print-none"
                                icon x-small
                                height="28"
                                width="28"
                                @click="toggleShowChildren(childItem_3)"
                                v-show="childItem_3.children"
                                :class="{rotate:childItem_3.isShowedChildren}">
                                  <v-icon>keyboard_arrow_down</v-icon>
                                </v-btn>
                              <span v-if="headItem.currency" v-html="$options.filters.currency(get(childItem_3, headItem), headItem.prefix || '', headItem.round)"></span>
                              <span v-else>{{get(childItem_3, headItem)}}</span>
                            </v-col>
                          </v-row >
                        </v-col>


                      </v-row >
                    </v-col>


                    </v-row >
                      </v-col>





              </v-row >

            </v-col>
            </v-row>

<!--
            <v-row no-gutters class="list-item flex-wrap total-footer" v-if="withTotalsFooter">
              <v-col cols="12" >
                <v-row class="flex-nowrap blue-grey white--text lighten-2 font-weight-bold" no-gutters>
                  <v-col class="item" v-for="(headItem, headIndex) in config.header">
                    <span> {{totalHeader[headItem.unix] || totalHeader[headItem.value]}} </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row > -->

        </v-container >





        <div class="corner-footer" v-if="withTotalsFooter">
            <div class="corner-title">
              <span class="pa-2">
                Total
              </span>
            </div >
          </div>


            <footer v-if="withTotalsFooter">
              <div class="footer-container" :style="{ width: (widthContainer) + 'px' }">
                <v-row no-gutters class=" flex-nowrap">
                  <v-col class="footer-item p-relative"
                  :class="[{'d-print-none': headItem.print == false},
                        headItem.print_width    ? 'print-'+headItem.print_width : '',
                        headItem.cell_width     ? 'width-'+headItem.cell_width : ''
                        ]"
                  v-for="(headItem, index) in config.header"
                  :key="'footer-item-'+index">

                      <span v-if="headItem.totalPrefix" class="blue-grey--text text--darken-2 total-icon">
                       {{headItem.totalPrefix}}
                      </span>

                      <span class="d-block">
                      {{ (totalHeader[headItem.unix] || ( totalHeader[headItem.value])? totalHeader[headItem.value].label : '-') }}
                      </span>

                  </v-col>
                </v-row>
              </div>
            </footer>

  </div>




  <nav class="right">

  </nav>

</div>





















  </div>
</template>
<script>

import _ from "lodash";
import moment from "moment";


export default {
  name  : "agTable",
  props: {
    config              : { default: ()=>{} , type: Object},
    dataTable           : { default: ()=>[] , type: Array},
    totales             : { default: ()=>{} , type: Object},
    sidebarClickeable   : { default: false , type: Boolean},
    itemClickeable      : { default: false , type: Boolean},
    withTotalsFooter    : { default: false , type: Boolean},
    withTotalSidebar    : { default: false , type: Boolean},
    totalCurrency       : { default: false , type: Boolean},
    withSidebarExtended : { default: true  , type: Boolean},
    isFullHeight        : { default: true  , type: Boolean},

    //loading           : { default: false , type: Boolean},

    /*dates: {default:()=>{return {
      dateInicio          : moment().startOf('month'),
      dateFin             : moment().endOf('month'),
      dateMonth           : moment().startOf('month').format("YY-MM"),
    }}, type:Object}*/

  },
  data  : () => ({
    dataTableFormated : [],
    dataFormated      : [],
    totalHeader       : {},

    //dateMenuInicio      : false,
    //dateMenuFin         : false,
    //dateMenuMonth       : false,
    //loadingDate         : false,
  }),

//https://github.com/mazipan/vue-currency-filter/blob/master/packages/vue-currency-filter/src/currency.ts
  filters: {
    currency: function (value, prefix = '', round = 2) {

      let result = 0.0
      const isNegative = String(value).charAt(0) === '-'

      value = _.round(value, round);

      if (isNegative) {
        value = String(value).slice(1);
      }

      const amount = parseFloat(value);
      if (_.isNumber(amount)) {
        result = amount
      }
      var result_entero = _.floor(result);
      var result_dec    = round > 0 ? result - result_entero : '';
      //var result_entero = this.formatPrice(result_entero);

      //coma decimal
      //result_entero = (value/1).toString().replace('.', ',');

      //puntos de unidades de mil
      result_entero = result_entero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");


      if (isNegative) {
        result_entero = '-' + result_entero
      }

      var dec = round > 0 ? `, <span class="dec">${result_dec}</span>` : '';


      // TODO -> condicion de decimales, no siempre son necesarios, y pueden causar problemas al imprimir -> condicion de decimales, no siempre son necesarios, y pueden causar problemas al imprimir
      result = `<span class="currency ${isNegative ? 'negative':''}">
                  <span class="prefix">
                    ${prefix}
                  </span>
                  ${result_entero} ${dec}
                </span>`

      return result
    }
  },



  computed:{
    isMobile(){
      return this.$store.getters.isMobile;
    },
    empresaSelected(){
      return this.$store.getters.empresaSelected;
    },
    /*
    datesFormated(){
      return {
        dateInicio          : this.dates.dateInicio.format('YYYY-MM-DD'),
        dateFin             : this.dates.dateFin.format('YYYY-MM-DD'),
        dateMonth           : this.dates.dateInicio.format("YY-MM"),
      }
    },
    dateInicioFormated(){
      return moment(this.dates.dateInicio).format("DD MMM");
    },
    dateMonthFormated(){
      return moment(this.dates.dateMonth+"-01", "YY-MM-DD").format("MMM");
    },
    dateFinFormated(){
      return moment(this.dates.dateFin).format("DD MMM");
    },
    */
    widthContainer(){
      if(!this.dataFormated || this.dataFormated.length == 0) return "";
      return this.dataFormated[0].data.length * 60;
    }
  },


  created() {
    //this.getData();
    if(this.dataTable){
      this.formatData();
    }
  },


  watch:{
    dataTable(){
      this.formatData();
    },
    config(){
      this.formatData();
    },
  },


  methods: {
    toggleShowChildren(item){
      item.isShowedChildren = !item.isShowedChildren;
      this.$forceUpdate();
    },
    clickSidebarItem(item){
      if(this.sidebarClickeable){
        this.$emit("click-sidebar", {item});
      }
    },
    clickItem(item, headItem){
      if(this.itemClickeable){
        this.$emit("click-item", { item, headItem });
      }
    },
    getHead(headItem, prop = 'label'){
      var r = null;
      //prop = prop || 'label';
      switch(prop){
        case 'label':
          if(this.isMobile && headItem.mobile){
              r = headItem.mobile;
          } else if(headItem.label){
            r = headItem.label;
          }else if(this.config.dateable){
            r = moment(headItem.unix * 1000).format("DD, MMM");
          }else{
            r = "no data"
          }
          break;
        case 'tooltip':
          if(headItem.tooltip){
            r = headItem.tooltip;
          }
          break;
        case 'print':
          r = headItem.label;
          if(headItem.print){
            r = headItem.print;
          }
          break;
      }
      return r;

    },


    get(item, headItem, defaultReturn = null){
      //si se manejan fechas en el header
      //value debe ser un unix
      if(this.config.dateable){
        if(_.isNumber(headItem.unix) && _.find(item.data, d => d.unix == headItem.unix) !== undefined){
          return _.find(item.data,d => d.unix == headItem.unix)[this.config.varSelected ];
        }
      }
      //si se manejan labels en el header
      if(item[headItem.value] !== undefined){
        return item[headItem.value];
      }
      if(_.get(item, headItem.value) !== undefined){
        return _.get(item, headItem.value);
      }
      return defaultReturn;
    },

    /*
    selectMonth(){
      this.dates.dateInicio = moment(this.dateMonth+"-01", "YY-MM-DD");
      this.dates.dateFin = moment(this.dateMonth+"-01", "YY-MM-DD").endOf("month");;
      this.dates.dateMenuMonth = false;
      //this.getData();
      this.$emit("changeDate", {
        dateInicio : this.dates.dateInicio,
        dateFin    : this.dates.dateFin,
      })
    },
    */

    formatPrice(value) {
      let val = (value/1).toString().replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    /*
    moveMonth(cant){
      this.dates.dateInicio = this.dates.dateInicio.add(cant, "month");
      this.dates.dateFin    = this.dates.dateFin.add(cant, "month");
      this.dates.dateMonth  = moment(this.dateMonth+"-01", "YY-MM-DD").add(cant, "month").format("YY-MM");
      this.$emit("changeDate", {
        dateInicio : this.dates.dateInicio,
        dateFin    : this.dates.dateFin,
      })
    },
    */


    formatData(){
      if(this.config.dateable){
        var dataTableFormated = _.map(_.cloneDeep(this.dataTable), item => {
          return this.formatChildDateable(item, this.config.variables);
        })
        this.dataTableFormated = dataTableFormated;
      }else{
        var dataTableFormated = _.map(_.cloneDeep(this.dataTable), item => {
          return this.formatChild(item);
        })
        this.dataTableFormated = dataTableFormated;
      }

        if(this.withTotalsFooter){
          if(this.totales){
            this.totalHeader = _.cloneDeep(this.totales);
          }else{
            this.calculateHeaderTotals();
          }
        }
    },

    calculateHeaderTotals(){

      var totalHeader = {};

      _.forEach(this.config.header, h => {
          var label = this.config.dateable ? h.unix : h.value;
          var count = 0;
        _.forEach(this.dataTable, item => {
          var cant = (totalHeader[label] || 0) + _.round(parseFloat(this.get(item, h, 0)), 2)
            totalHeader[label] = cant;
            if(cant > 0 || h.averageWithZero){
              count++;
            }
        });

        if( h.average){
          if(count > 0 ){
            totalHeader[label] /= count;
          }else{
            totalHeader[label] = 0;
          }
        }

      });

        this.totalHeader = _.mapValues(totalHeader, (th, label) => {
          var headerItem = _.find(this.config.header, {value: label}) || null;                                     // si es dateable, sera null
          var isCurrency = this.totalCurrency || ((headerItem && headerItem.currency) ? headerItem.currency : false);
          var prefix     = this.totalCurrency ? "$ " : ((headerItem && headerItem.prefix) ? headerItem.prefix : "")
          var suffix     = (headerItem && headerItem.suffix) ? headerItem.suffix : ""
          return {
            label : prefix + (isCurrency ? this.formatPrice(_.round(th, 0))  :  _.round(th, 2)) + suffix,
            value: th,
            headerItem,
            isCurrency,
            prefix,
            suffix
          }
        })

    },

    formatChildDateable(item, variables){
      item.total = {};

      //inicializa datos en 0
      //util para casos sin datos
      _.forEach(variables, v => {
        item.total[v.varName] = 0;
      })

      var dataFormated = _.map(_.cloneDeep(item.data), d => {
        var dFormated = _.cloneDeep(d);
        _.forEach(variables, v => {
          if(v.round !== undefined){
            dFormated[v.varName] = _.round(dFormated[v.varName], v.round);
          }
          if(_.isNumber(dFormated[v.varName])){
            item.total[v.varName] += dFormated[v.varName];
            if(v.round){
              item.total[v.varName] = _.round(item.total[v.varName], v.round)
            }
          }
          /*
          if(v.currency){
            dFormated[v.varName] = this.formatPrice(dFormated[v.varName]);
          }
          if(v.prefix){
            dFormated[v.varName] = v.prefix + "" +dFormated[v.varName];
          }
          if(v.suffix){
            dFormated[v.varName] = dFormated[v.varName] + "" + v.suffix;
          }
          */
        });


        return dFormated
      });


      if(item.children){
        item.children = _.map(_.cloneDeep(item.children), c => {
          return this.formatChildDateable(c, variables);
        });
      }
      return {...item, data:dataFormated}
    },
    formatChild(item, parent){
      var itemFormated = {};
      itemFormated[this.config.sidebar.label] =  item[this.config.sidebar.label];
      _.forEach(this.config.header, headItem => {
        var formatedValue = this.get(item, headItem);

        if(headItem.round !== undefined){
          formatedValue = _.round(formatedValue, headItem.round);
        }
        /*
        if(headItem.currency){
          formatedValue = this.formatPrice(formatedValue);
        }
        if(headItem.prefix){
          formatedValue = headItem.prefix+""+formatedValue;
        }
        if(headItem.suffix){
          formatedValue = formatedValue+""+headItem.suffix;
        }
        */

        itemFormated[headItem.value] = formatedValue;
      })

      itemFormated.isShowedChildren = false;

      if(item.trabajador){
        itemFormated.trabajador = item.trabajador;
      }
      if(item.obj){
        itemFormated.obj = item.obj;
      }
      if(item.type){
        itemFormated.type = item.type;
      }
      if(item.clickItem){
        itemFormated.clickItem = item.clickItem;
      }
      if(item.showOptionalData){
        itemFormated.showOptionalData = item.showOptionalData;
      }

      if(item.children){
        itemFormated.children = _.map(_.cloneDeep(item.children),  childItem => {
          return this.formatChild(childItem, itemFormated);
        })
      }

      if(parent){
        itemFormated.parent = parent;
      }

      return itemFormated;
    }
  }
}
</script>

<style lang="scss">
.ag-table{
    .currency{
      display: inline-block;
      width: 100%;
      box-sizing: border-box;
      text-align: right;
      &.negative{
        color: red;
      }
      .prefix{
        margin-right: 0.5em;
      }
      .dec{
        opacity: 0.5;
      }
    }
}
</style>
<style lang="scss" scoped>

  $header_height:     35px;
  $header_day_width:  15px;
  $header_day_height: 19px;
  $ex_header_height:  0px;
  $nav_width:         400px;
  $ex_nav_width:      120px;
  $nav_right_width:   0px;
  $day_height:        30px;
  $day_width:         60px;
  $item_min_width:    100px;



  $nav_width_mobile:      150px;
  $ex_nav_width_mobile:   80px;
  $item_min_width_mobile: 90px;

  $weekend_color:       rgba(66,165,245, 0.1);
  $hover_color:         rgba(0, 0, 0, 0.1);
  $hover_color_sidebar: rgb(187,222,251); //blue 100
  $hover_color_day:     rgba(0, 0, 0, 0.2);
  $warn_color:          #ef9a9a;               //red 100
  $full_color:          #c8e6c9;               // green 100

  //--------------------------------------

$width_xxs  : 40px;
$width_xs  : 50px;
$width_sm  : 60px;
$width_md  : 80px; // default
$width_lg  : 100px;
$width_xl  : 120px;
$width_xxl : 140px;

@mixin varwidth{
  &.width-xxs{
    width: $width_xxs;
  }
  &.width-xs{
    width: $width_xs;
  }
  &.width-sm{
    width: $width_sm;
  }
  &.width-md{
    width: $width_md;
  }
  &.width-lg{
    width: $width_lg;
  }
  &.width-xl{
    width: $width_xl;
  }
  &.width-xxl{
    width: $width_xxl;
  }
  @media print{
    &.print-xxs{
      width: $width_xxs;
      min-width: $width_xxs;
      max-width: $width_xxs;
    }
    &.print-xs{
      width: $width_xs;
      min-width: $width_xs;
      max-width: $width_xs;
    }
    &.print-sm{
      width: $width_sm;
      min-width: $width_sm;
      max-width: $width_sm;
    }
    &.print-md{
      width: $width_md;
      min-width: $width_md;
      max-width: $width_md;
    }
    &.print-lg{
      width: $width_lg;
      min-width: $width_lg;
      max-width: $width_lg;
    }
    &.print-xl{
      width: $width_xl;
      min-width: $width_xl;
      max-width: $width_xl;
    }
    &.print-xxl{
      width: $width_xxl;
      min-width: $width_xxl;
      max-width: $width_xxl;
    }
  }
}

  // --------------------------------------


  .truncate {
    width:100%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }


  .ag-table{
    //border: 1px solid blue;
    position: relative;
    font-family: "Roboto", sans-serif;

    //TODO hacer manejo por fuera, la tabla no es responsable de su altura
    &.full-height{
      height: calc(100vh - 90px); // << 90px hack
    }

    &:not(.full-height){
      height: inherit;
      //max-height: 500px;
      max-height: inherit;// calc(100vh - 90px); // << 90px hack
      //min-height: 100px;
    }

    button.p-absolute{
      position: absolute !important;
    }



    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      opacity: 0.5;
    }

    ::-webkit-scrollbar-corner {
      background: #cfd8dc;
    }

    ::-webkit-scrollbar-track {
      background: #cfd8dc;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: rgb(69,90,100);//blue grey 700
    }

    &.extended{
      .corner{
        width: $nav_width + $ex_nav_width;
      }
      .corner-footer{
        width: $nav_width + $ex_nav_width;
      }
      .container-tl{
        header{
          min-width: calc(100% + #{$nav_width + $ex_nav_width});
          .header-container{
            padding-left: $nav_width + $ex_nav_width;
          }
        }

        footer{
          min-width: calc(100% + #{$nav_width + $ex_nav_width});
          .footer-container{
            padding-left: $nav_width + $ex_nav_width;
          }
        }
        nav.left{
          width: $nav_width + $ex_nav_width;
        }
        .table{
          left: $nav_width + $ex_nav_width;
          min-width: calc(100% - #{$nav_width + $ex_nav_width});
        }
      }
    }

    .corner {
      position: absolute;
      left: 0px;
      top: 0px;
      z-index: 4;
      background: white;
      color: #607d8b; // blue grey 500
      width: $nav_width;
      height: $header_height + $ex_header_height;
      border-bottom: 1px solid #b0bec5; // blue grey 200
      box-sizing: border-box;
        .corner-title {
          height: inherit;
          display: block;
          text-align:left;
          box-sizing: border-box;
          font-size: 12px;
          vertical-align: top;
          position: relative;
          span{
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: 100%;
          }
      }
      .extend-corner {
        position: absolute;
        left: $nav-width;
        top: 0px;
        width: $ex_nav_width;
        height: $header_height + $ex_header_height;
        background: white;
        overflow: hidden;
        border-bottom: 1px solid #b0bec5; // blue grey 200
        box-sizing: border-box;
        .ex-corner-title {
          height: inherit;
          //width: 50px; //temp
          width: inherit;
          display: inline-block;
          margin-right: -1px;
          text-align: right;
          box-sizing: border-box;
          font-size: 12px;
          vertical-align: top;
          position: relative;
          span {
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: 100%;
            padding-right: 14px !important;
          }
        }
      }
      .extend-bottom-corner {
        height: $ex_header_height;
        left: 0px;
        top: $header-height;
        position: absolute;
        background: red;
      }
    }

    .corner-footer {
      position:sticky;
      left: 0px;
      bottom: 0px;
      z-index: 4;
      background: #90a4ae; // blue grey 300
      //color: white;
      width: $nav_width;
      height : $day_height;
      margin-bottom : -$day_height;
      box-sizing: border-box;
      border-top: 1px solid #546e7a;
      border-right: 1px solid #546e7a;
        .corner-title {
          height: inherit;
          display: block;
          text-align:left;
          box-sizing: border-box;
          vertical-align: top;
          position: relative;
          font-weight: bold;
          padding: 4px 6px;
      }
    }

    nav.right {
      background: #eceff1; //blue grey 50
      position: absolute;
      right: 0px;
      top: 0px;
      width: $nav_right_width;
      height: auto;
      z-index: 5;
    }

    .container-tl {
      min-width: calc(100% - #{$nav_right_width});
      height: inherit;
      max-height: inherit;
      position: relative;
      overflow: scroll;
      margin: 0px;

      header {
        height: $header_height + $ex_header_height;
        width: fit-content;
        top: 0px;
        //width: fit-content;
        min-width: calc(100% + #{$nav_width});
        position: sticky;
        font-size: 10px;
        background: white;
        z-index: 3;
        border-bottom: 1px solid #b0bec5; // blue grey 200
        box-sizing: border-box;
        color: #455a64;
        //padding-top: 8px;

        .header-container {
          position: relative;
          padding-left: $nav_width;
          width: 100%;
          .header-item{
            @include varwidth;
            padding: 5px;
            font-size: 12px;
            min-width: $item_min_width;
            cursor: default;
            text-align: center;
          }
        }

        /*
        .agno-calendario {
          display: inline-block;
          font-size: 10px;
          .agno {
            position: sticky;
            left: $nav_width + $ex_nav_width + 5px;
            display: inline-block;
          }
          .meses {
            display: block;
          }
          .mes-calendario {
            display: inline-block;
            .mes {
              display: inline-block;
              position: sticky;
              left: $nav_width + $ex_nav_width + 5px;
            }
            .dias {
              .dia-calendario {
                width: $day_width;
                height: $header_day_height;
                display: inline-block;
                vertical-align: top;
                font-size: 12px;
                margin-right: -1px; //temp
                border-left: 1px solid #cfd8dc; //blue grey 100
                box-sizing: border-box;
                padding-left: 6px;
                &.hover{
                  background: $hover_color;
                }
                &.weekend{
                  background: $weekend_color;
                }
              }
            }
          }
        }
        */
        .header-extend-container {
          height: $ex-header-height;
          color: pink;
          left: 0px;
          top: $header-height;
          position: absolute;
        }
      }

      footer {
        width: fit-content;
        bottom: 0px;
        min-width: calc(100% + #{$nav_width});
        height: $day_height;
        position: sticky;
        //color: white;
        z-index: 3;
        box-sizing: border-box;
        //background-color: #78909c;
        background-color: #b0bec5; //blue grey 200

        .footer-container{
          position: relative;
          padding-left: $nav_width;
          width: 100%;
          border-top: 1px solid #546e7a;
          .footer-item{
            @include varwidth;
            padding: 3px;
            min-width: $item_min_width;
            height: $day_height;
            cursor: default;
            overflow: hidden;

            border-right: 1px solid #546e7a !important; // blue grey 100
            box-sizing: border-box;

            .total-icon{
              position: absolute;
              left: 3px;
              top: 3px;
              vertical-align: text-top;
            }
            span{
              text-align: right;
              margin-right: 1em;
              margin-top: 3px;
              font-weight: bold;
            }
          }
        }

      }

      nav.left {
        //background: #78909c; //blue grey 400
        position: sticky;
        left: 0px;
        width: $nav_width;
        height: auto;
        z-index: 2;
        border-right: 1px solid #b0bec5 !important; // blue grey 200
        overflow: hidden;
        .nav-item-list {
          margin-top: -1px;

          .child-nav-item {
            border-top: 1px solid #b0bec5 !important; // blue grey 200
          }
          .nav-item {
            //border-bottom: 1px solid #b0bec5 !important; // blue grey 200
            border-top: 1px solid #b0bec5 !important; // blue grey 200
          }
          .nav-item ,
          .child-nav-item {
            width: $nav_width;
            min-height: $day_height;
            box-sizing: border-box;
            background: white;
            & > *{
              vertical-align: middle;
            }
            .tree-icon{
              transition: 0.5s all ease;
              &.rotate{
                transform: rotate(180deg);
              }
            }
            .item-title {
              //padding: 5px 3px;
              //width:calc(100% - 40px); <------ TODO revisar
              width: 100%;
              font-size: 14px;
              display: inline-block;
              height: $day_height - 1px; //1px por los bordes del contenedor


              &.clickeable{
                cursor: pointer;
                &:hover{
                  background: $hover_color_sidebar !important;
                }
              }

              .subtitle {
                display: block;
                font-size: 12px;
              }
            }

            &.has-children{
              .item-title{
                width:calc(100% - 40px);
              }
            }
            /*
            .light {
              width: 20px;
              height: $day-height;
              display: inline-block;
              vertical-align: top;
              position: relative;
              &:after {
                position: absolute;
                left: calc(50% - 5px);
                top: calc(50% - 5px);
                display: block;
                content: "";
                width: 10px;
                height: 10px;
                border-radius: 50%;
              }
              &.red:after {
                background: #f44336; //red 500
              }
            }
            */
          }
        }

        .extend-nav-list {
          background: white;
          width: $ex_nav_width;
          position: absolute;
          left: $nav_width;
          top: 0px;
          overflow: hidden;

          .child-ex-nav-item{
            border-top: 1px solid #b0bec5 !important; // blue grey 200
          }
          .ex-nav-item {
            border-bottom: 1px solid #b0bec5 !important; // blue grey 200
          }
          .child-ex-nav-item,
          .ex-nav-item {
            min-height: $day_height;
            box-sizing: border-box;
            width: inherit;
            &.hover{
              background: $hover_color;
            }
            .num {
              //width: 50px; //temp
              width:inherit;
              //display: inline-block;
              //margin-right: -1px;
              box-sizing: border-box;
              padding-right: 14px;
              min-height: $day_height - 1px;
              line-height: $day_height - 1px;
              font-size: 12px;
              text-align:right;
              span {
                font-size: 10px;
                color: #546e7a;
              }
            }
          }
        }

        .nav-item-total-footer{
          padding-top: 3px;
        }
      }

      .table {
        position: absolute;
        left: $nav_width;
        top: $header_height + $ex_header_height;
        background: white;
        min-width: calc(100% - #{$nav_width});
        margin-top: -1px;


        .list-item-children,
        .list-item {
          //display: block;
          min-height: $day_height;
          box-sizing: border-box;
          margin: 0px;

          /*&:hover{
            background: $hover_color !important;
          */
          .row-items{
            min-width: fit-content;
            page-break-inside: avoid;
          }
          .item{
            @include varwidth;
            //width: $day_width;
            height: $day_height;
            line-height: $day_height - 1px;
            border-right : 1px solid rgb(176,190,197) !important; // blue grey 100
            border-top: 1px solid rgb(176,190,197) !important;
            box-sizing: border-box;
            //display: inline-block;
            //margin-right: -1px;
            //margin-top: -1px;
            padding-right: 1em;
            position: relative;
            text-align: right;
            font-size: 14px;
            vertical-align: top;
            min-width: $item_min_width;
            cursor: default;
            //cursor:
            &.clickeable{
              cursor: pointer;
              &:hover{
                background: $hover_color !important;
              }
            }
            &.full{
              background: $full_color;
            }
            &.warn{
              background: $warn_color;
            }
          }
        }
      }
    }
  }














  .ag-table.mobile{
    &.full-height{
      height: calc(100vh - 180px);
    }
    .corner{
      width: $nav_width_mobile;
      .extend-corner{
        left: $nav_width_mobile;
        width: $ex_nav_width_mobile;
      }
    }
    .corner-footer{
      width: $nav_width_mobile;
    }
    .container-tl{
      header{
        min-width: calc(100% + #{$nav_width_mobile});
        .header-container{
          padding-left: $nav_width_mobile;
          .header-item{
            min-width: $item_min_width_mobile;
          }
        }
      }

      footer {
        min-width: calc(100% + #{$nav_width_mobile});
        .footer-container{
          padding-left: $nav_width_mobile;
          .footer-item{
            min-width: $item_min_width_mobile;
            font-size: 12px;
          }
        }
      }
      nav.left{
        width: $nav_width_mobile;
        .nav-item-list{
          .nav-item ,
          .child-nav-item {
            width: $nav_width_mobile;
          }
        }
        .extend-nav-list{
          width: $ex_nav_width_mobile ;
          left: $nav_width_mobile ;
        }
      }
      .table{
        left: $nav_width_mobile;
        min-width: calc(100% - #{$nav_width_mobile});

        .list-item-children,
        .list-item
        {
          .item{
            min-width: $item_min_width_mobile;
          }
        }
      }
    }

    &.extended{
      .corner{
        width: $nav_width_mobile + $ex_nav_width_mobile;
      }
      .corner-footer{
          width: $nav_width_mobile + $ex_nav_width_mobile;
      }
      .container-tl{
        header{
          min-width: calc(100% + #{$nav_width_mobile + $ex_nav_width_mobile});
          .header-container{
            padding-left: $nav_width_mobile + $ex_nav_width_mobile;
          }
        }

        footer{
          min-width: calc(100% + #{$nav_width_mobile + $ex_nav_width_mobile});
          .footer-container{
            padding-left: $nav_width_mobile + $ex_nav_width_mobile;
          }
        }
        nav.left{
          width: $nav_width_mobile + $ex_nav_width_mobile;
        }
        .table{
          left: $nav_width_mobile + $ex_nav_width_mobile;
          min-width: calc(100% - #{$nav_width_mobile + $ex_nav_width_mobile});
        }
      }
    }
  }








  @media print{

    $nav_width:         180px;
    $ex_nav_width:      0px;
    $item_min_width:    80px;

    .ag-table {
      max-height: initial;
      font-size: 10px;
      .corner{
        width: $nav_width + $ex_nav_width;
        .corner-title{
          font-size: 10px;
        }
        .extend-corner{
          width: $ex_nav_width;
          left: $nav-width;
        }
      }
      .corner-footer{
        width: $nav_width;
        position: initial;
        page-break-inside : avoid;
        page-break-before: auto;
      }
      .container-tl {
        //width: 100%;
        height: auto;
        max-height: none;
        overflow:visible;
        nav.left {
          width: $nav_width + $ex_nav_width;

          .nav-item-list {
            .nav-item ,
            .child-nav-item {
              width: $nav_width;
              .item-title{
                font-size: 12px;
                width: 100%;
                padding-left: 0px;
              }
            }
            .child-nav-item{
              //page-break-inside: avoid;
            }
          }
          .extend-nav-list{
            //width: 80px !important;
            width: $ex_nav_width;
            left: $nav_width;
          }
        }
        header{
          min-width: calc(100% - #{$nav_width + $ex_nav_width});
          position: initial;
          .header-container{
            padding-left: $nav_width + $ex_nav_width;
            .header-item {
              padding: 0px;
              min-width: $item_min_width;
              max-width: $item_min_width;
              span {
                font-size: 12px;
              }
            }
          }
        }

        footer{
          min-width: calc(100% - #{$nav_width + $ex_nav_width});
          position: initial;
          .footer-container{
            padding-left: $nav_width + $ex_nav_width;
            border-top: 1px solid grey;
            .footer-item{
              @include varwidth;
              padding: 0px;
              min-width: $item_min_width;
              max-width: $item_min_width;
              span {
                font-size: 12px;
              }
            }
          }
        }
        .container{
          width: unset;
        }
        .table {
          left: $nav_width + $ex_nav_width;
          min-width: calc(100% - #{$nav_width - $ex_nav_width});
          .list-item-children,
          .list-item{
            .item{
              min-width: $item_min_width;
              max-width: $item_min_width;
              height: unset;
              min-height: $day_height;
              font-size: 12px;

              //page-break-inside : avoid;
              //page-break-before: auto;
            }
          }
        }
      }
    }

    .nav-item-total-footer,
    .total-footer{
        color: black !important;
        background: white !important;
        background-color: white !important;
        *, .blue-grey.lighten-2{ //patch
          color: black !important;
          background: white !important;
          background-color: white !important;
        }
    }
  }


</style>
